import AnnouncementBanner from './AnnouncementBanner';

export default AnnouncementBanner;
